export default "/images/Exotics_full.svg?47957fca8f9be9b79737177524218b8c";